// Generated from contracts/gaming/v1/media-witness-format.json. Do not edit.
export const mediaWitnessFormat = {
  "status": "Propuesto",
  "version": 1,
  "boxType": "uuid",
  "boxBytes": 124,
  "uuidHex": "a79331dcb5594ae6a41de03ffb36b830",
  "maxFragmentBytes": 16777216,
  "uuidPattern": "^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$",
  "offsets": {
    "version": 24,
    "reserved": 25,
    "challengeId": 28,
    "sourceId": 44,
    "sampleOrdinal": 60,
    "decodeTime": 64,
    "timescale": 72,
    "captureMonotonicMs": 76,
    "captureServerMs": 84,
    "sampleSha256": 92
  },
  "composition": {
    "version": 2,
    "boxBytes": 156,
    "purposeOffset": 25,
    "digestOffset": 124,
    "purposes": {
      "gaming": 1,
      "conventional": 2
    },
    "serialization": "UTF-8 JSON with recursively sorted object keys, no whitespace; finite nonnegative safe numbers; exact schema; max 8192 bytes"
  },
  "runtimeComposition": {
    "version": 3,
    "boxBytes": 164,
    "captureUpperMonotonicMsOffset": 156,
    "purpose": "gaming only; both capture bounds and challenge commit the exact selected frame; no ENDING authority"
  },
  "causalComposition": {
    "version": 4,
    "profile": "monotonic-causal-v1",
    "boxBytes": 332,
    "boxType": "uuid",
    "uuidHex": "a79331dcb5594ae6a41de03ffb36b830",
    "purposes": {
      "runtime": 1,
      "program-return": 2,
      "current-video": 3
    },
    "maxSampleOrdinal": 599,
    "maxCompositionBytes": 8192,
    "maxEventBytes": 8192,
    "maxBindingBytes": 8192,
    "maxRequestBytes": 16384,
    "maxPendingPerPurpose": 2,
    "byteOrder": "big-endian",
    "fields": [
      {
        "name": "boxSize",
        "offset": 0,
        "bytes": 4,
        "encoding": "uint32be"
      },
      {
        "name": "boxType",
        "offset": 4,
        "bytes": 4,
        "encoding": "ASCII uuid"
      },
      {
        "name": "uuid",
        "offset": 8,
        "bytes": 16,
        "encoding": "raw UUID bytes"
      },
      {
        "name": "version",
        "offset": 24,
        "bytes": 1,
        "encoding": "uint8 =4"
      },
      {
        "name": "purpose",
        "offset": 25,
        "bytes": 1,
        "encoding": "uint8: runtime=1, program-return=2, current-video=3"
      },
      {
        "name": "reserved",
        "offset": 26,
        "bytes": 2,
        "encoding": "zero bytes"
      },
      {
        "name": "challengeId",
        "offset": 28,
        "bytes": 16,
        "encoding": "UUIDv4 bytes"
      },
      {
        "name": "receiptId",
        "offset": 44,
        "bytes": 16,
        "encoding": "UUIDv4 bytes"
      },
      {
        "name": "eventId",
        "offset": 60,
        "bytes": 16,
        "encoding": "UUIDv4 bytes"
      },
      {
        "name": "bindingSha256",
        "offset": 76,
        "bytes": 32,
        "encoding": "raw SHA256 bytes"
      },
      {
        "name": "eventSha256",
        "offset": 108,
        "bytes": 32,
        "encoding": "raw SHA256 bytes"
      },
      {
        "name": "compositionSha256",
        "offset": 140,
        "bytes": 32,
        "encoding": "raw SHA256 bytes"
      },
      {
        "name": "collectorProcessIdSha256",
        "offset": 172,
        "bytes": 32,
        "encoding": "SHA256 UTF-8 exact ID"
      },
      {
        "name": "collectorGenerationSha256",
        "offset": 204,
        "bytes": 32,
        "encoding": "SHA256 UTF-8 exact ID"
      },
      {
        "name": "sourceIdSha256",
        "offset": 236,
        "bytes": 32,
        "encoding": "SHA256 UTF-8 exact ID"
      },
      {
        "name": "sampleOrdinal",
        "offset": 268,
        "bytes": 4,
        "encoding": "uint32be <=599"
      },
      {
        "name": "decodeTime",
        "offset": 272,
        "bytes": 8,
        "encoding": "uint64be <=MAX_SAFE_INTEGER"
      },
      {
        "name": "timescale",
        "offset": 280,
        "bytes": 4,
        "encoding": "uint32be >0"
      },
      {
        "name": "originalExpiresAtMs",
        "offset": 284,
        "bytes": 8,
        "encoding": "uint64be <=MAX_SAFE_INTEGER"
      },
      {
        "name": "receiptSequence",
        "offset": 292,
        "bytes": 8,
        "encoding": "uint64be 1..MAX_SAFE_INTEGER"
      },
      {
        "name": "sampleSha256",
        "offset": 300,
        "bytes": 32,
        "encoding": "raw SHA256 bytes"
      }
    ],
    "serialization": "Digests: SHA256 over UTF-8 JSON, recursively sorted object keys, no whitespace; exact closed schemas, finite nonnegative safe numbers, no duplicate keys. UUIDs canonical lowercase v4. Hash strings decoded to 32 bytes. Exactly one witness per selected sample in a bounded fragment; exact box length, UUID, version, purpose and zero reserved bytes required. No floats, padding, trailing bytes or extensions. Receipt/event/composition/binding/process/generation/source/sample identity and original exclusive expiry must match stored receipt and reparsed sample; mismatches deny. Versions1-3 retain their existing byte layout and meaning. No remote captureServerMs or source-counter projection."
  }
} as const;
